import { addDoc, collection } from 'firebase/firestore'
import moment from 'moment'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { db } from '../../../utitilties/firebase'
import CloseIco from '../../../assets/icons/close.png'
const AddSurveyModal = ({ client, therapist, onClose }) => {
    const [startDate, setStartDate] = useState(new Date())
    const [endDate, setEndDate] = useState(new Date())
    const [frequency, setFrequency] = useState('Daily')
    const [loading, setLoading] = useState(false)

    const navigation = useNavigate()

    const createDates = (type) => {
        let dates = []

        let start = new Date(startDate)
        let end = new Date(endDate)

        let diff = moment(end).diff(moment(start), type) + 1


        for (let i = 0; i < diff; i++) {
            dates.push(moment(start).add(i, type))
        }

        return dates;
    }
    const minimumDateError = (endDate) => {
        if (endDate < startDate) {
            alert('End date should be greater than start date.')

        }

    }

    const addSurvey = async () => {

        if (endDate < startDate) {
            alert('End date should be greater than start date.')
            return
        }


        setLoading(true)

        let dates = []

        let type = 'days'




        if (frequency == 'Weekly') {
            type = 'week'
        }
        else if (frequency == 'Monthly') {
            type = 'month'
        }

        dates = createDates(type)

        console.log(dates, 'date...')

        const promises = dates.map(async (date, index) => {

            // await firestore()
            //     .collection('Surveys')
            //     .add({
            //         userId: client.id,
            //         physioUserId: userData.id,
            //         startDate,
            //         endDate,
            //         frequency,
            //         dueDate: new Date(dates[index]),
            //         timestamp: new Date()
            //     }).catch((error) => {
            //         console.log(error)

            //     })
            const docRef = await addDoc(collection(db, 'Surveys'), {
                userId: client.id,
                physioUserId: therapist.id,
                startDate,
                endDate,
                frequency,
                dueDate: new Date(dates[index]),
                timestamp: new Date()
            })
        }
        )
        await Promise.all(promises)
        console.log('here')
        setLoading(false)
        alert('Survey Added')
        const noOfSurveys = dates.length
        // sendPushNotification([client.id], { title: 'New Surveys Added', body: `${noOfSurveys} surveys added by ${userData.name} from ${moment(startDate).format("DD/MM/YYYY")} to ${moment(endDate).format("DD/MM/YYYY")}` })
        onClose()
        return



    }
    return (
        <div style={{ padding: 25, display: 'flex', flexDirection: 'column' }}  >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} >
                <h1>Add Survey</h1>
                <img
                    src={CloseIco}
                    style={{ marginTop: 10, width: 18, height: 18, cursor: 'pointer' }}
                    onClick={onClose}
                />
            </div>
            <div style={{ marginTop: 50, display: 'flex', flexDirection: 'column' }} >
                <label>Start Date</label>

                <input
                    type="date"
                    className="text_input"
                    value={moment(startDate).format('yyyy-MM-DD')}
                    onChange={(e) => setStartDate(new Date(e.target.value))}
                    placeholder="Start date"
                />
                <label>End Date</label>
                <input
                    type="date"
                    className="text_input"
                    value={moment(endDate).format('yyyy-MM-DD')}
                    onChange={(e) => setEndDate(new Date(e.target.value))}
                    placeholder="End date"
                />
            </div>
            <div>
                <label>
                    <input
                        type="radio"
                        value="Daily"
                        checked={frequency === 'Daily'}
                        onChange={(e) => setFrequency(e.target.value)}
                        name="options"
                        style={{ marginRight: 5 }}
                    />
                    Daily
                </label>
                <label style={{ marginLeft: 15, marginRight: 15 }} >
                    <input
                        type="radio"
                        value="Weekly"
                        checked={frequency === 'Weekly'}
                        onChange={(e) => setFrequency(e.target.value)}
                        name="options"
                        style={{ marginRight: 5 }}
                    />
                    Weekly
                </label>
                <label>
                    <input
                        type="radio"
                        value="Monthly"
                        checked={frequency === 'Monthly'}
                        onChange={(e) => setFrequency(e.target.value)}
                        name="options"
                        style={{ marginRight: 5 }}
                    />
                    Monthly
                </label>
            </div>
            <div onClick={addSurvey} style={{ marginTop: 25 }} className='btn' >
                <p>Add survey</p>
            </div>
        </div>
    )
}

export default AddSurveyModal